[
  {
    "code": "MM-07",
    "name": "Ayeyarwady"
  },
  {
    "code": "MM-02",
    "name": "Bago"
  },
  {
    "code": "MM-14",
    "name": "Chin"
  },
  {
    "code": "MM-11",
    "name": "Kachin"
  },
  {
    "code": "MM-12",
    "name": "Kayah"
  },
  {
    "code": "MM-13",
    "name": "Kayin"
  },
  {
    "code": "MM-03",
    "name": "Magway"
  },
  {
    "code": "MM-04",
    "name": "Mandalay"
  },
  {
    "code": "MM-15",
    "name": "Mon"
  },
  {
    "code": "MM-16",
    "name": "Rakhine"
  },
  {
    "code": "MM-01",
    "name": "Sagaing"
  },
  {
    "code": "MM-17",
    "name": "Shan"
  },
  {
    "code": "MM-05",
    "name": "Tanintharyi"
  },
  {
    "code": "MM-06",
    "name": "Yangon"
  }
]